<template>
  <div id="indexNew" style="position: fixed;height: 100%;width: calc(100% - 240px);padding-right:2%;padding-bottom: 3.5%;">
    <el-row type="flex" style="height:15%;width: 100%;">
      <el-col class="col" style="padding-right:1%;" :span="4">
        <div class="colDiv">
          <div class="backlog" @click="Click('1')">
            <div class="indexBtn">
              <el-button type="text">
                <span class="span2">{{hydws}}</span>
              </el-button>
            </div>
            <span class="span1">单位会员</span>
          </div>
        </div>
      </el-col>
      <el-col class="col" style="padding-right:1%;" :span="4">
        <div class="colDiv">
          <div class="Beread" @click="Click('2')">
            <div class="indexBtn">
              <el-button type="text">
                <span class="span2">{{hydwdbs}}</span>
              </el-button>
            </div>
            <span class="span1">单位待办</span>
          </div>
        </div>
      </el-col>
      <el-col class="col" style="padding-right:1%;" :span="4">
        <div class="colDiv">
          <div class="Dwjf" @click="Click('3')">
            <div class="indexBtn">
              <el-button type="text">
                <span class="span2">{{hydwjfs}}</span>
              </el-button>
            </div>
            <span class="span1">单位会员交费</span>
          </div>
        </div>
      </el-col>
      <el-col class="col" style="padding-right:1%;" :span="4">
        <div class="colDiv">
          <div class="task" @click="Click('4')">
            <div class="indexBtn">
              <el-button type="text">
                <span class="span2">{{hygrs}}</span>
              </el-button>
            </div>
            <span class="span1">个人会员</span>
          </div>
        </div>
      </el-col>
      <el-col class="col" :span="4" style="padding-right:1%;">
        <div class="colDiv">
          <div class="Endorsement" ref="div1" @click="Click('5')">
            <div class="indexBtn">
              <el-button type="text">
                <span class="span2">{{hygrdbs}}</span>
              </el-button>
            </div>
            <span class="span1">个人待办</span>
          </div>
        </div>
      </el-col>

      <el-col class="col" :span="4">
        <div class="colDiv">
          <div class="Grjf" @click="Click('6')">
            <div class="indexBtn">
              <el-button type="text">
                <span class="span2">{{hygrjfs}}</span>
              </el-button>
            </div>
            <span class="span1">个人会员交费</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="rowline">
      <div class="colDiv2">
        <div class="line"></div>
        <div class="message_top">
          <span class="MT_left">
            <i class="iconfont icon-tongji"></i>
            <span>单位会员情况统计</span>
          </span>
        </div>
        <div class="message_content">
          <div class="echartsBox staticStyle" style="relative">
            <div id="bin1" class="echartsBoxLeft" style="width: 50%;"></div>
            <div id="pie1" class="echartsBoxRight" style="width: 50%;"></div>
          </div>
        </div>
      </div>
      <div class="colDiv3">
        <div class="line"></div>
        <div class="message_top">
          <span class="MT_left">
            <i class="iconfont icon-tongji"></i>
            <span>个人会员情况统计</span>
          </span>
        </div>
        <div class="message_content" style="margin-bottom: 2px;">
          <div class="echartsBox staticStyle" style="relative">
            <div id="bin2" class="echartsBoxLeft" style="width: 50%;"></div>
            <div id="pie2" class="echartsBoxRight" style="width: 50%;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="rowline">
      <div class="colDiv2">
        <div class="line"></div>
        <div class="message_top">
          <span class="MT_left">
            <i class="iconfont icon-tongji"></i>
            <span>单位会员新增情况统计</span>
          </span>
        </div>
        <div class="message_content">
          <div class="echartsBox staticStyle" style="relative">
            <div id="zhu1" class="echartsBoxLeft" style="width: 100%;"></div>
          </div>
        </div>
      </div>
      <div class="colDiv3">
        <div class="line"></div>
        <div class="message_top">
          <span class="MT_left">
            <i class="iconfont icon-tongji"></i>
            <span>个人会员新增情况统计</span>
          </span>
        </div>
        <div class="message_content" style="margin-bottom: 2px;">
          <div class="echartsBox staticStyle" style="relative">
            <div id="zhu2" class="echartsBoxLeft" style="width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入基本模板
  let echarts = require('echarts/lib/echarts')
  // 引入柱状图组件
  require('echarts/lib/chart/bar')
  // 引入饼状图
  require('echarts/lib/chart/pie')
  // 引入主题
  import 'echarts/theme/infographic.js'
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  require('echarts/lib/component/legend')
  import Calendar from 'vue-calendar-component';

  export default {
    name: "indexNew",
    data() {
      return {
        loading: false,
        msecs: 0,
        userid: this.CONSTANT.currentUser.userid,
        //当前登陆用户
        currentUser: this.CONSTANT.currentUser,
        // 待办文件
        dbwj: 0,
        // 待阅文件
        dywj: 0,
        // 通知通告
        noticeNum: 0,
        //站内信息
        messageNum: 0,
        hydws: "0", //单位会员数
        hygrs: "0", //个人会员数
        hydwdbs: "0", //单位待办数
        hygrdbs: "0", //个人待办数
        hydwjfs: "0", //单位会员交费数
        hygrjfs: "0", //个人会员交费数
        hydwsjzt: [], //单位会员数据状态统计
        hydwhyzt: [], //单位会员会员状态统计
        hygrsjzt: [], //个人会员数据状态统计
        hygrhyzt: [], //个人会员会员状态统计
        hydwxz: [], //单位会员新增情况数据统计
        hygrxz: [], //个人会员新增情况数据统计
        resizefun: null,
      };
    },
    components: {
      Calendar,
    },
    //实现窗口自适应 add by yushch 20191227
    mounted() {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //获取htmlDom
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置html的font-size
      htmlDom.style.fontSize = htmlWidth / 120 + 'px';
      window.addEventListener('resize', (e) => {
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        //获取htmlDom
        let htmlDom = document.getElementsByTagName('html')[0];
        //设置html的font-size
        htmlDom.style.fontSize = htmlWidth / 120 + 'px';
      })


      this.init()
      this.day_init()
    },
    created() {
    },
    methods: {
      init: function() {
        this.getDwCount();
        this.getGrCount();
        this.getDwDbCount();
        this.getGrDbCount();
        this.getDwData();
        this.getGrData();
        this.getDwXzData();
        this.getGrXzData();
        for (let i in this.currentUser.roles) {
          if(this.currentUser.roles[i] != null){
            if (this.currentUser.roles[i].rolename == "cfpa_approve") {
            }else{
              this.getDwJfCount();
              this.getGrJfCount()
            }
          }
        }
      },
      //实现自适应
      day_init() {
        const self = this; //因为箭头函数会改变this指向，指向windows。所以先把this保存
        var todaypieId = document.getElementById("bin1");
        var todaypieId1 = document.getElementById("bin2");
        var todaypieId2 = document.getElementById("pie1");
        var todaypieId3 = document.getElementById("pie2");
        var todaypieId4 = document.getElementById("zhu1");
        var todaypieId5 = document.getElementById("zhu2");
        setTimeout(() => {
          window.onresize = function() {
            //   self.chart = echarts.init(self.$refs.myEchart);
            self.chart_today = echarts.init(
              todaypieId
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId1
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId2
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId3
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId4
            );
            self.chart_today.resize();
            self.chart_today = echarts.init(
              todaypieId5
            );
            self.chart_today.resize();
          };
        }, 20);
      },
      //获取单位会员总数
      getDwCount: function() {
        let vm = this;
        var params = {
          //sjzt: "08",
          sjzt: "11",
          hyztList: ["1", "2", "3"]
        }
        vm.$axios.post("/home/doSearchDwCount", params).then(function(res) {
            vm.hydws = res.data.result;
            /**
            var passwordChgFlag = vm.currentUser.passwordChgFlag;
            if (passwordChgFlag == "F") {
              vm.$alert(
              "为保证信息安全，请点击右上角用户名，前往用户中心，按照密码校验规则修改密码",
              '提示',
              {
                confirmButtonText: '确定',
                type: 'warning'
              });
            } */
          }.bind(vm),function(error) {
            console.log(error);
          }
        );
      },
      //获取个人会员总数
      getGrCount: function() {
        let vm = this;
        var params = {
          //sjzt: "08",
          sjzt: "11",
          hyztList: ["1", "2", "3"]
        }
        vm.$axios.post("/home/doSearchGrCount", params).then(
          function(res) {
            vm.hygrs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取单位待办总数
      getDwDbCount: function() {
        let vm = this;
        var params = {
          username: this.currentUser.userid,
          rolename: this.currentUser.roles[0].rolename,
        }
        vm.$axios.post("/home/doSearchDwDbCount", params).then(
          function(res) {
            vm.hydwdbs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取个人待办总数
      getGrDbCount: function() {
        let vm = this;
        var params = {
          username: this.currentUser.userid,
          rolename: this.currentUser.roles[0].rolename,
        }
        vm.$axios.post("/home/doSearchGrDbCount", params).then(
          function(res) {
            vm.hygrdbs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取单位交费情况
      getDwJfCount: function() {
        let vm = this;
        var params = {}
        vm.$axios.post("/home/doSearchDwJfCount", params).then(
          function(res) {
            vm.hydwjfs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取个人交费情况
      getGrJfCount: function() {
        let vm = this;
        var params = {}
        vm.$axios.post("/home/doSearchGrJfCount", params).then(
          function(res) {
            vm.hygrjfs = res.data.result;
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取单位会员情况统计数据
      getDwData: function() {
        let vm = this;
        var params = {
          hylx: "10",
        }
        vm.hydwsjzt=[]
        vm.$axios.post("/home/sjzt", params).then(
          function(res) {
            for (let i in res.data.result) {
              var n = {
                name: res.data.result[i].sjztmc,
                value: res.data.result[i].sjztsl
              }
              vm.hydwsjzt.push(n)
            }
            this.binChart1()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
        var params = {
          hylx: "10",
        }
        vm.hydwhyzt=[]
        vm.$axios.post("/home/hyzt", params).then(
          function(res) {
            for (let i in res.data.result) {
              var n = {
                name: res.data.result[i].hyztmc,
                value: res.data.result[i].hyztsl
              }
              vm.hydwhyzt.push(n)
            }
            this.pieChart1()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取个人会员情况统计数据
      getGrData: function() {
        let vm = this;
        var params = {
          hylx: "20",
        }
        vm.hygrsjzt=[];
        vm.$axios.post("/home/sjzt", params).then(
          function(res) {
            for (let i in res.data.result) {
              var n = {
                name: res.data.result[i].sjztmc,
                value: res.data.result[i].sjztsl
              }
              vm.hygrsjzt.push(n)
            }
            this.binChart2()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
        var params = {
          hylx: "20",
        }
        vm.hygrhyzt=[];
        vm.$axios.post("/home/hyzt", params).then(
          function(res) {
            for (let i in res.data.result) {
              var n = {
                name: res.data.result[i].hyztmc,
                value: res.data.result[i].hyztsl
              }
              vm.hygrhyzt.push(n)
            }
            this.pieChart2()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );

      },
      //获取单位会员新增情况统计数据
      getDwXzData: function() {
        let vm = this;
        var params = {
          hylx: "10",
        }
        vm.$axios.post("/home/doXzsqhyByRq", params).then(
          function(res) {
            vm.hydwxz = res.data.result;
            this.barChart1()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      //获取个人会员新增情况统计数据
      getGrXzData: function() {
        let vm = this;
        var params = {
          hylx: "20",
        }
        vm.$axios.post("/home/doXzsqhyByRq", params).then(
          function(res) {
            vm.hygrxz = res.data.result;
            this.barChart2()
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      },
      // 左侧饼图
      binChart1: function() {
        var myChart = echarts.init(document.getElementById('bin1'), 'infographic');
        var optionPie = {
          title: {},
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            top: 'bottom',
            data: [],
          },
          series: [{
            name: '',
            type: 'pie', // 设置图表类型为饼图
            center: ['45%', '50%'],
            radius: '48%', // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
            data: this.hydwsjzt,
            labelLine: {
              normal: {
                length: 3
              }
            },
          }],
        };
        myChart.setOption(optionPie);
      },

      // 右侧玫瑰图
      pieChart1: function() {
        var myChart = echarts.init(document.getElementById('pie1'), 'infographic');
        var optionPie = {
          title: {},
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],

          },
          series: [{
            name: ' ',
            type: 'pie',
            // radius: [10, 80],
            center: ['50%', '49%'],
            roseType: 'area',
            labelLine: {
              normal: {
                length: 1
              }
            },
            data: this.hydwhyzt,

          }],
        };
        myChart.setOption(optionPie);
      },

      binChart2: function() {
        var myChart = echarts.init(document.getElementById('bin2'), 'infographic');
        var optionPie = {
          title: {},
          tooltip: {
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            top: 'bottom',
            data: [],
          },
          series: [{
            name: '',
            type: 'pie', // 设置图表类型为饼图
            center: ['45%', '50%'],
            radius: '48%', // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
            data: this.hygrsjzt,
            labelLine: {
              normal: {
                length: 3
              }
            },
          }],
        };
        myChart.setOption(optionPie);
      },

      // 右侧玫瑰图
      pieChart2: function() {
        var myChart = echarts.init(document.getElementById('pie2'), 'infographic');
        var optionPie = {
          title: {},
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            data: [],

          },
          series: [{
            name: ' ',
            type: 'pie',
            // radius: [10, 80],
            center: ['50%', '49%'],
            roseType: 'area',
            labelLine: {
              normal: {
                length: 1
              }
            },
            data: this.hygrhyzt,

          }],
        };
        myChart.setOption(optionPie);
      },

      // 左侧柱状图
      barChart1: function() {
        var myChart = echarts.init(document.getElementById('zhu1'), 'infographic');
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            x: 'right',
            data: ['新增会员数', '新增申请数']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '12%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: this.hydwxz.rqs,
            axisLabel: {
              interval: 0,
              rotate: 20, //代表逆时针旋转45度
            }
          }],
          yAxis: [{
            type: 'value',
            minInterval: 1
          }],
          series: [{
              name: '新增会员数',
              type: 'bar',
              data: this.hydwxz.xzhys
            },
            {
              name: '新增申请数',
              type: 'bar',
              data: this.hydwxz.xzsqs
            },
          ],
        };
        myChart.setOption(option);
      },
      // 右侧柱状图
      barChart2: function() {
        var myChart = echarts.init(document.getElementById('zhu2'), 'infographic');
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            x: 'right',
            data: ['新增会员数', '新增申请数'],

          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '12%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: this.hygrxz.rqs,
            axisLabel: {
              interval: 0,
              rotate: 20, //代表逆时针旋转45度
            },
          }],
          yAxis: [{
            type: 'value',
            minInterval: 1
          }],
          series: [{
              name: '新增会员数',
              type: 'bar',
              data: this.hygrxz.xzhys
            },
            {
              name: '新增申请数',
              type: 'bar',
              data: this.hygrxz.xzsqs
            },
          ],
          color: ['#e87c25', '#2ba6c9']
        };
        myChart.setOption(option);
      },
      Click: function(val) {
        if (val == "1") {
          this.$router.push({
            path: "/member/hydwcertificate",
          });
        } else if (val == "2") {
          for (let i in this.currentUser.roles) {
            if (this.currentUser.roles[i].rolename == "company-admin") {
              this.$router.push({
                path: "/member/hydwsh",
              });
            }
            if (this.currentUser.roles[i].rolename == "cfpa_approve") {
              this.$router.push({
                path: "/member/hydwsp",
              });
            }
          }
        } else if (val == "3") {
          for (let i in this.currentUser.roles) {
            if (this.currentUser.roles[i].rolename == "cfpa_approve") {} else {
              this.$router.push({
                path: "/member/hydwrh",
              });
            }
          }
        } else if (val == "4") {
          this.$router.push({
            path: "/member/hygrcertificate",
          });
        } else if (val == "5") {
          for (let i in this.currentUser.roles) {
            if (this.currentUser.roles[i].rolename == "person-admin") {
              this.$router.push({
                path: "/member/hygrsh",
              });
            }
            if (this.currentUser.roles[i].rolename == "cfpa_approve") {
              this.$router.push({
                path: "/member/hygrsp",
              });
            }
          }
        } else if (val == "6") {
          for (let i in this.currentUser.roles) {
            if (this.currentUser.roles[i].rolename == "cfpa_approve") {} else {
              this.$router.push({
                path: "/member/hygrrh",
              });
            }
          }

        }
      }
    },
  };
</script>
<style lang="scss">
  @import "../../common/scss/mixin.scss";
  @import "../../common/scss/iconfont/iconfont.css";

  #indexNew {
    .backlog {
      height: 100%;
      background: url(../../../static/images/home/pic_orange.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: 8% 10px;
    }

    .Beread {
      height: 100%;
      background: url(../../../static/images/home/pic_purple.png) no-repeat;
      background-size: 100% 100%;
      padding: 8% 10px;
    }

    .task {
      height: 100%;
      background: url(../../../static/images/home/pic_blue.png) no-repeat;
      background-size: 100% 100%;
      padding: 8% 10px;
    }

    .Endorsement {
      height: 100%;
      background: url(../../../static/images/home/pic_red.png) no-repeat;
      background-size: 100% 100%;
      padding: 8% 10px;
    }

    .Dwjf {
      height: 100%;
      background: url(../../../static/images/home/pic_green.png) no-repeat;
      background-size: 100% 100%;
      padding: 8% 10px;
    }

    .Grjf {
      height: 100%;
      background: url(../../../static/images/home/pic_yellow.png) no-repeat;
      background-size: 100% 100%;
      padding: 8% 10px;
    }

    .span1 {
      display: inline-block;
      width: 100%;
      color: white;
      text-align: right;
      right: 0;
      font-size: 1.2rem;
      padding-right: 0.3125rem;
    }

    .span2 {
      display: inline-block;
      width: 100%;
      color: white;
      text-align: right;
      right: 0;
      font-size: 2.5rem;
      padding-right: 0.3125rem;
    }

    .indexBtn {
      text-align: right;
    }

    .colDiv {
      height: 100%;
      width: 100%;
      border: none;
      box-shadow: none;
      cursor: pointer;
    }

    .rowline {
      width: 100%;
      height: 38%;
      display: block;

    }

    .colDiv2 {
      border-top: 3px solid #3BAAFF;
      height: calc(100% - 10px);
      width: 49%;
      border: 1px solid #ddd;
      box-shadow: none;
      margin-top: 0;
      display: inline-block;
      background: #ffffff;
    }

    .colDiv3 {
      border-top: 3px solid #3BAAFF;
      margin-left: 1%;
      margin-top: 10px;
      height: calc(100% - 10px);
      width: calc(50% - 5px);
      display: inline-block;
      border: 1px solid #ddd;
      -webkit-box-shadow: none;
      box-shadow: none;
      background: #ffffff;
    }

    .line {
      width: 100%;
      height: 4px;
      background: #026CB5;
    }

    .message_top {
      padding: 11px 15px;
      padding-right: 10px;
      border-bottom: 1px solid #ddd;
      overflow: hidden;
      color: #026CB5;
      font-size: 1.2rem;
    }

    .message_content {
      width: 100%;
      height: calc(100% - 3.125rem)
    }

    .echartsBox {
      margin: 0;
      padding: 0;
      border: 0;
      height: calc(100% - 0.125rem)
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/home/HomeList.vue